import React from "react";
import classes from "./home.module.css";
import image from '../../assets/images/img1.svg';


const Home = () => {
  return <div className={classes.container}>
      <div className={classes.left}>
          <img src={image} width="200" height="200" alt="background"/>
      </div>
      <div className={classes.right}>
          <h1>Expense Manager </h1>
          <section>
              <p>Manange your all the transcation and never ran out of money.</p>
              <ul>
                  <li>Add you daily expense and income.</li>
                  <li>Analyise the expense and track the expense</li>
                  <li>We are providing charts for analysis </li>
                  <li>And Most important, all of your data will be at your device only. </li>
              </ul>
          </section>
      </div>
  </div>;
};

export default Home;
